var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgenciesSidebarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 96 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    strokeWidth: 5,
    fill: "#858585",
    d: "M352 583ZM80 936V456l320-240 240 180q-20 0-40 4.5T563 413L400 291 140 486v390h200v60H80Zm320 0v-76q0-21 10.5-39.5T439 791q46-27 96.5-41T640 736q54 0 104.5 14t96.5 41q18 11 28.5 29.5T880 860v76H400Zm60-60h360v-29q-42-24-87.227-37.5Q687.546 796 640 796t-92.773 14Q502 824 460 848v28Zm180-180q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Zm0-60q25.5 0 42.75-17.25T700 576q0-25.5-17.25-42.75T640 516q-25.5 0-42.75 17.25T580 576q0 25.5 17.25 42.75T640 636Zm0 240Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenciesSidebarIcon);
export default __webpack_public_path__ + "static/media/agencies-sidebar-icon.80f3d478b4531bfdc631f85bfb27457e.svg";
export { ForwardRef as ReactComponent };